// extracted by mini-css-extract-plugin
export default {"bag":"bag_bag__Mt8Ws","bagLabel":"bag_bagLabel__iMfQJ","addButton":"bag_addButton__7WFKD"};